import React, { useState, useEffect, useCallback } from "react";
import { Sidebar, Menu, MenuItem, SubMenu, sidebarClasses } from "react-pro-sidebar";
import { FcBullish, FcPositiveDynamic, FcServices, FcPrevious, FcNext, FcUndo, FcKey } from "react-icons/fc";
import axios from "axios";
import Modal from "react-modal"; // Adicionando o modal
import { useNavigate } from "react-router-dom";
import { useMenuContext } from "../../context/MenuContext"; // Importando o contexto
import jwtDecode from 'jwt-decode';

import logo from "../../imagens/Logo.png";
import logosigla from "../../imagens/logosigla.png";
import "../../styles/menu.scss";
import { toast } from "react-toastify";

Modal.setAppElement("#root"); // Necessário para acessibilidade

const Dashs = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [conteudo, setConteudo] = useState("/default");
  const [tipoUsuario, setTipoUsuario] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false); // Estado para o modal
  const [novaSenha, setNovaSenha] = useState(""); // Senha
  const [confirmarSenha, setConfirmarSenha] = useState(""); // Confirmação da senha
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { menuPai, menuFilho, atualizarMenus } = useMenuContext(); // Usando o MenuContext
  const API_URL = process.env.REACT_APP_API_URL;

  // Função para buscar os menus e atualizar o contexto
  const fetchMenus = useCallback(async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const headers = { Authorization: `Bearer ${token}` };
      const [menuPaiResponse, menuFilhoResponse] = await Promise.all([
        axios.get(`${API_URL}/api/menu/pai`, { headers }),
        axios.get(`${API_URL}/api/menu/filho`, { headers }),
      ]);

      atualizarMenus(menuPaiResponse.data, menuFilhoResponse.data); // Atualiza o contexto
    } catch (error) {
      toast.error("Erro ao buscar os menus.");
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        navigate("/login");
      }
    }
  }, [API_URL, navigate, atualizarMenus]);

  // Função para decodificar o token e configurar o tipo de usuário
  const obterIdUsuario = useCallback(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.ID_TP_USER) {
        setTipoUsuario(decoded.ID_TP_USER);
      } else {
        console.warn("Token inválido. O campo ID_TP_USER não foi encontrado.");
        toast.error("Token inválido. Faça login novamente.");
        navigate("/login");
      }
    } catch (error) {
      console.error("Erro ao decodificar o token:", error);
      toast.error("Erro ao processar autenticação. Faça login novamente.");
      navigate("/login");
    }
  }, [navigate]);

  // Carregar dados quando o componente for montado
  useEffect(() => {
    //console.log("Página /dashs carregada no front-end.");
    const carregarDados = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Token de autenticação não encontrado.");
        return;
      }

      try {
        await obterIdUsuario();
        await fetchMenus();
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    };

    carregarDados();
  }, [fetchMenus, obterIdUsuario]);

  // Função para realizar logoff
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        throw new Error("Token de autenticação não encontrado.");
      }



      await axios.post(
        `${API_URL}/api/auth/logout`,
        {}, // Corpo vazio
        {
          headers: {
            Authorization: `Bearer ${token}`, // Enviando o token no cabeçalho
          },
        }
      );

      // Remover token e redirecionar

      toast.success("Logout realizado com sucesso.");
      navigate("/login");
      localStorage.removeItem("authToken");
    } catch (err) {
      console.error("Erro no logout:", err.response?.data || err.message);
      toast.error("Erro ao realizar logout. Tente novamente.");
    }
  };

  const salvarLog = async (idUsuario, idCampanha) => {
    const dataAcesso = new Date().toISOString(); // Captura a data e hora atual
    try {
      const token = localStorage.getItem("authToken");
      const headers = { Authorization: `Bearer ${token}` };

      await axios.post(`${API_URL}/api/logs`, {
        idUsuario,
        paginaAcessada: idCampanha,
        dataAcesso,
      }, { headers });

      console.log("Log salvo com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar log de acesso:", error);
      toast.error("Erro ao registrar o acesso.");
    }
  };


  // Função para atualizar o menu ao selecionar um item
  const handleMenuClick = (link, idCampanha) => {
    const token = localStorage.getItem("authToken");
    document.body.style.overflow = "hidden"; // Esconder barra de rolagem ao acessar uma campanha
    if (!token) {
      console.error("Token de autenticação não encontrado.");
      toast.error("Sessão expirada. Faça login novamente.");
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      //console.log("Token decodificado:", decoded);

      const idUsuario = decoded?.id; // Obtém o ID do usuário do token
      // console.log("user capturado no token", idUsuario)


      if (!idUsuario) {
        console.error("ID do usuário não encontrado no token.");
        toast.error("Sessão inválida. Faça login novamente.");
        navigate("/login");
        return;
      }

      // Adiciona um parâmetro único à URL
      //const timestamp = new Date().getTime();
      //const separator = link.includes('?') ? '&' : '?';
      const newLink = link;

      //`${link}$t=${timestamp}`;

      //console.log("linkgerado: ", newLink);

      // Salvar o log de acesso
      salvarLog(idUsuario, idCampanha);
      setConteudo(newLink); // Atualiza o conteúdo do menu com a URL única
      document.body.style.overflow = "hidden";

      // Salvar o log de acesso
      // salvarLog(idUsuario, idCampanha);
      // setConteudo(link); // Atualiza o conteúdo do menu
    } catch (error) {
      console.error("Erro ao processar o token JWT:", error);
      toast.error("Erro na autenticação. Faça login novamente.");
      navigate("/login");
    }
  };

  //menuocultaconfig
  const handleConfigClick = (link, idCampanha) => {
    const token = localStorage.getItem("authToken");
    document.body.style.overflow = "auto"; // Exibir barra de rolagem ao acessar Configurações
    if (!token) {
      console.error("Token de autenticação não encontrado.");
      toast.error("Sessão expirada. Faça login novamente.");
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      //console.log("Token decodificado:", decoded);

      const idUsuario = decoded?.id; // Obtém o ID do usuário do token
      // console.log("user capturado no token", idUsuario)


      if (!idUsuario) {
        console.error("ID do usuário não encontrado no token.");
        toast.error("Sessão inválida. Faça login novamente.");
        navigate("/login");
        return;
      }


      const newLink = link;


      //console.log("linkgerado: ", newLink);

      // Salvar o log de acesso
      //salvarLog(idUsuario, idCampanha);
      setConteudo(newLink);
      document.body.style.overflow = "auto";


    } catch (error) {
      console.error("Erro ao processar o token JWT:", error);
      toast.error("Erro na autenticação. Faça login novamente.");
      navigate("/login");
    }
  };

  const handleDiarioClick = () => {
    const localUrl = `${window.location.origin}/diario`;
    setConteudo(localUrl);
  };



  // Função para alterar senha
  const alterarSenha = async () => {
    if (novaSenha !== confirmarSenha) {
      setError("As senhas não coincidem.");
      return;
    }

    if (novaSenha.length < 8) { // Validação do comprimento da senha
      setError("A senha deve ter pelo menos 8 caracteres.");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const headers = { Authorization: `Bearer ${token}` };

      await axios.put(`${API_URL}/api/auth/alterar-senha`, { senha: novaSenha }, { headers });

      setNovaSenha(""); // Limpa os campos
      setConfirmarSenha("");
      setError(null);
      setModalIsOpen(false);
      toast.success("Senha alterada com sucesso!");
    } catch (error) {
      toast.error("Erro ao alterar senha:", error);
      setError("Erro ao alterar senha.");
    }
  };

  const renderModal = () => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={() => setModalIsOpen(false)}
      contentLabel="Alterar Senha"
      className="custom-modal"
      overlayClassName="custom-modal-overlay"
      shouldCloseOnOverlayClick={true} // Fecha o modal ao clicar no overlay
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escurecido
          zIndex: 1000, // Garante que esteja acima de outros elementos
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "#fff",
          overflow: "auto",
          borderRadius: "8px",
          outline: "none",
          padding: "20px",
          width: "400px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <h2>Alterar Senha</h2>
      <div className="form-group">
        <label htmlFor="novaSenha">Nova Senha:</label>
        <input
          id="novaSenha"
          type="password"
          className="custom-input"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="confirmarSenha">Confirmar Senha:</label>
        <input
          id="confirmarSenha"
          type="password"
          className="custom-input"
          value={confirmarSenha}
          onChange={(e) => setConfirmarSenha(e.target.value)}
        />
      </div>
      {error && <p className="error-message">{error}</p>}
      <div className="modal-footer">
        <button className="btn btn-primary" onClick={alterarSenha}>
          Alterar
        </button>
        <button className="btn btn-secondary" onClick={() => setModalIsOpen(false)}>
          Cancelar
        </button>
      </div>
    </Modal>
  );

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#F0F8FF",
            color: "#9c9e9a",
          },
        }}
      >
        {/* Botão para alternar o estado */}
        <div style={{ padding: "10px", textAlign: "center" }}>
          <button
            onClick={() => setCollapsed(!collapsed)}
            style={{
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {collapsed ? (
              <div
                style={{
                  backgroundImage: `url(${logosigla})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  height: "70px",
                  width: "70px",
                }}
              />
            ) : (
              <div
                style={{
                  backgroundImage: `url(${logo})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  height: "80px",
                  width: "160px",
                  marginRight: "10px",
                }}
              />
            )}
            {collapsed ? (
              <FcNext style={{ color: "#9c9e9a", fontSize: "22px" }} />
            ) : (
              <FcPrevious style={{ color: "#9c9e9a", fontSize: "22px" }} />
            )}
          </button>
        </div>

        <Menu>
          <MenuItem icon={<FcPositiveDynamic />}>Dashboards</MenuItem>
          {[1, 2, 3, 4].includes(tipoUsuario) && (
            <MenuItem onClick={handleDiarioClick}>Diário de Bordo</MenuItem>
          )}
          {menuPai.map((pai) => (
            <SubMenu key={pai.MENU_PAI_ID} label={pai.NOME_MENU_PAI} icon={<FcBullish />}>
              {menuFilho
                .filter((filho) => filho.MENU_PAI_ID === pai.MENU_PAI_ID)
                .map((filho) => (
                  <MenuItem
                    key={filho.MENU_FILHO_ID}
                    onClick={() => handleMenuClick(filho.link, filho.MENU_FILHO_ID)} // Atualiza o conteúdo ao clicar
                  >
                    {filho.Descricao}
                  </MenuItem>
                ))}
            </SubMenu>
          ))}
          {[1, 2].includes(tipoUsuario) && (
            <SubMenu label="Configurações" icon={<FcServices />}>
              <MenuItem onClick={() => handleConfigClick("/cliente")}>Clientes</MenuItem>
              <MenuItem onClick={() => handleConfigClick("/campanha")}>Campanhas</MenuItem>
              <MenuItem onClick={() => handleConfigClick("/usuarios")}>Usuários</MenuItem>
              <MenuItem onClick={() => handleConfigClick("/acesso")}>Acessos</MenuItem>
            </SubMenu>
          )}
          <MenuItem icon={<FcKey />} onClick={() => setModalIsOpen(true)}>
            Alterar Senha
          </MenuItem>
          <MenuItem icon={<FcUndo />} onClick={handleLogout}>
            Sair
          </MenuItem>
        </Menu>
      </Sidebar>

      <main style={{ flex: 1 }}>
        <iframe
          id="powerbi-iframe"
          src={conteudo}
          title="Conteúdo do Menu"
          style={{
            width: "100%",
            height: "110%", // Subtrai o espaço para o rodapé, ajuste conforme necessário
            border: "none",
            overflow: "hidden", // Impede a barra de rolagem
          }}
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      </main>
      {renderModal()}
    </div>
  );
};

export default Dashs;
